import React, { useState } from 'react';
import { Dialog } from 'components/organisms/Modal/Dialog';
import { Input, Button } from 'components/atoms/index';
import { Icon } from '@/icons';
import AcademyStudentTable from 'components/organisms/Table/AcademyStudentTable';
interface StudentData {
  id: string;
  name: string;
  email: string;
  grade: string;
  status: 'active' | 'inactive';
  registrationDate: string;
  academyCode: string;
  birthDate: string;
}

interface StudentSelectionModalProps {
  open: boolean;
  onOk: (selectedStudents: StudentData[]) => void;
  onCancel: () => void;
  availableStudents: StudentData[];
  title?: string;
  showAcademyCode?: boolean;
}

const StudentSelectionModal: React.FC<StudentSelectionModalProps> = ({
  open,
  onOk,
  onCancel,
  availableStudents,
  title = "학생 선택",
  showAcademyCode = true
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedStudents, setSelectedStudents] = useState<StudentData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  React.useEffect(() => {
    if (open) {
      console.log('📋 StudentSelectionModal - availableStudents:', availableStudents.length);
      console.log('데이터:', availableStudents);
    }
  }, [open, availableStudents]);

  // 모달이 닫힐 때 상태 초기화
  React.useEffect(() => {
    if (!open) {
      setCurrentPage(1);
      setSearchTerm('');
      setSelectedStudents([]);
    }
  }, [open]);

  const filteredStudents = availableStudents.filter(student =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      alert('검색어를 입력해주세요.');
      return;
    }
    
    const filtered = availableStudents.filter(student =>
      student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    if (filtered.length === 0) {
      alert('검색 결과가 없습니다.');
    } else {
      alert(`${filtered.length}명의 학생을 찾았습니다.`);
    }
  };

  const handleStudentSelect = (student: StudentData) => {
    console.log('handleStudentSelect 호출:', student.name, student.id);
    console.log('현재 선택된 학생 수:', selectedStudents.length);
    
    const isSelected = selectedStudents.find(s => s.id === student.id);
    
    if (isSelected) {
      console.log('학생 선택 해제');
      setSelectedStudents(selectedStudents.filter(s => s.id !== student.id));
    } else {
      console.log('학생 선택 추가');
      setSelectedStudents([...selectedStudents, student]);
    }
  };

  const handleOk = () => {
    if (selectedStudents.length === 0) {
      alert('학생을 선택해주세요.');
      return;
    }
    onOk(selectedStudents);
    setSelectedStudents([]);
    setSearchTerm('');
  };

  const handleCancel = () => {
    setSelectedStudents([]);
    setSearchTerm('');
    onCancel();
  };

  if (!open) return null;

  return (
    <Dialog
      onOk={handleOk}
      onCancel={handleCancel}
      okText="선택"
      cancelText="취소"
      className="!max-w-[800px] !w-full"
    >
      <div className='p-5 space-y-6'>
        <div className='mb-6'>
          <h3 className='text-xl font-bold text-gray-900'>{title}</h3>
        </div>


        {/* 선택된 학생 수 */}
        {/* <div className='text-sm text-gray-600'>
          선택된 학생수: {selectedStudents.length}명
        </div> */}

                  {/* 학생 테이블 */}
          <AcademyStudentTable
            data={filteredStudents}
            selectedStudents={selectedStudents}
            onStudentSelect={handleStudentSelect}
            onSelectAll={(students) => setSelectedStudents(students)}
            type="selection"
            showSearch={true}
            showPagination={true}
            currentPage={currentPage}
            pageSize={pageSize}
            total={filteredStudents.length}
            showAcademyCode={showAcademyCode}
            onPageChange={(page) => {
              console.log('페이지 변경:', page);
              setCurrentPage(page);
            }}
          />
      </div>
    </Dialog>
  );
};

export default StudentSelectionModal; 